export const stripNonReadableCharacters = (text: string) =>
  text.replace(/[\p{Cc}\p{Cf}\p{Co}\p{Cn}]/gu, '');
